import { render, staticRenderFns } from "./RflmChecklist.vue?vue&type=template&id=5df1e4a8&scoped=true"
import script from "./RflmChecklist.vue?vue&type=script&lang=ts"
export * from "./RflmChecklist.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=5df1e4a8&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df1e4a8",
  null
  
)

export default component.exports